import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';
import { Alert, Button, Paper, Stack, Typography } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { GargiAudience } from '../../interfaces/models';
import { saveGargiAudience } from '../../services/gargi';
import { count } from '../Models/common';
import { actionError } from '../../../../shared/gargi/actionError';

// An audience Gargi defined in chat, counted live: save it as a cohort (Build Your Own), then explore or use it.
const AudienceCard: FC<{ audience: GargiAudience; onJourney?: (audience: GargiAudience) => void }> = ({ audience, onJourney }) => {
  const navigate = useNavigate();
  const save = useMutation({ mutationFn: () => saveGargiAudience(audience.id) });
  return (
    <Paper variant='outlined' sx={{ p: 1.75, borderRadius: 2.5 }}>
      <Stack direction='row' spacing={1} alignItems='center'>
        <GroupsRoundedIcon fontSize='small' color='primary' />
        <Typography variant='subtitle2' fontWeight={700} sx={{ flex: 1 }}>{audience.name}</Typography>
        <Typography variant='subtitle2' fontWeight={800}>{count(audience.size)} customers</Typography>
      </Stack>
      {audience.description && <Typography variant='body2' color='text.secondary' sx={{ mt: 0.5 }}>{audience.description}</Typography>}
      <Stack direction='row' spacing={1} sx={{ mt: 1.25 }} flexWrap='wrap' useFlexGap>
        {save.data
          ? <Button size='small' variant='contained' onClick={() => navigate(`/audiences/${save.data.cohortId}`)}>Open audience</Button>
          : <Button size='small' variant='contained' disabled={save.isPending} onClick={() => save.mutate()}>{save.isPending ? 'Saving…' : 'Save as audience'}</Button>}
        {onJourney && <Button size='small' onClick={() => onJourney(audience)}>Design a journey for them</Button>}
      </Stack>
      {save.data && <Typography variant='caption' color='text.secondary' sx={{ display: 'block', mt: 0.75 }}>
        {save.data.created ? 'Saved' : 'Already saved'} as “{save.data.name}” in Audiences → Build Your Own; it is re-counted each time a journey runs.
      </Typography>}
      {save.isError && <Alert severity='error' sx={{ mt: 1 }}>{actionError(save.error, 'The audience could not be saved.')}</Alert>}
    </Paper>
  );
};

export default AudienceCard;
